import { Field, SpacerVertical, Typography } from '@klarna/bubble-ui'
import React, { useCallback } from 'react'

import CampaignLayout from 'common/components/campaign-layout'
import currency from 'common/utils/currency'
import styles from './index.css'
import { useDarkModeContext } from 'common/contexts/dark-mode'
import useEligibilityPaymentMethodCategoryAwareTranslate from 'common/hooks/use-eligibility-payment-method-category-aware-translate'
import useTheme from 'common/hooks/use-theme'
import useTranslate from 'common/hooks/use-translate'

function AmountInput({ label, value, onChange }) {
  const normalizedValue = value ? String(parseInt(value, 10) / 100) : value
  const isDarkMode = useDarkModeContext()
  const handleChange = useCallback(
    value => {
      const normalizedValue = value.replace(/\D/g, '')
      onChange(normalizedValue ? String(parseInt(normalizedValue, 10) * 100) : normalizedValue)
    },
    [onChange]
  )

  const onBlur = useCallback(
    e => {
      e.target.value = value
    },
    [value]
  )

  return (
    <div className={isDarkMode ? styles.amountInputDark : ''}>
      <Field
        id="amount-input"
        isUnderlined
        label={label}
        type="number"
        value={normalizedValue}
        onChange={handleChange}
        onBlur={onBlur}
      />
    </div>
  )
}

function ChooseAmount({
  amount,
  min,
  max,
  setAmount,
  onSubmit
}: {
  amount: string
  min: number
  max: number
  setAmount: Function
  onSubmit: Function
}) {
  const translate = useTranslate()
  const eligibilityPaymentMethodCategoryAwareTranslate = useEligibilityPaymentMethodCategoryAwareTranslate()
  const { issuerName } = useTheme()

  return (
    <CampaignLayout
      id="choose-amount"
      title={eligibilityPaymentMethodCategoryAwareTranslate(
        'eligibility.pre_assessment.choose_amount.title',
        { issuerName }
      )}
      summary={eligibilityPaymentMethodCategoryAwareTranslate(
        'eligibility.pre_assessment.choose_amount.summary',
        { issuerName }
      )}
      buttonProps={{
        onClick: onSubmit,
        disabled: !amount,
        children: translate('eligibility.pre_assessment.choose_amount.continue')
      }}
    >
      <SpacerVertical spaceToken="space.300" />
      <Typography textToken="text-style/text/labels/body/medium">
        {translate('eligibility.pre_assessment.choose_amount.input_description')}
      </Typography>
      <AmountInput
        label={translate('eligibility.pre_assessment.choose_amount.input_label', {
          min: currency.format(min, true),
          max: currency.format(max, true)
        })}
        value={amount}
        onChange={setAmount}
      />
    </CampaignLayout>
  )
}

export default ChooseAmount
